export default __webpack_public_path__ + "static/nyoung-376cc712830f748be88feaefb12bd7bd.jpeg";